module.exports = __webpack_public_path__ + "img/cn_qrcode_1.afe02f48.jpg";